import React from 'react'
import Header from '../../Components/Header'
import stamping from "../../imagens/stamping/stamping.png"
import stamping2 from "../../imagens/stamping/stamping2.png"
import stamping3 from "../../imagens/stamping/stamping3.png"
import stamping4 from "../../imagens/stamping/stamping4.png"
import stamping5 from "../../imagens/stamping/stamping5.png"
import stamping6 from "../../imagens/stamping/stamping6.JPG"
import stamping7 from "../../imagens/stamping/stamping7.JPG"
import stamping8 from "../../imagens/stamping/stamping8.JPG"
import stamping9 from "../../imagens/stamping/stamping9.JPG"
import StampingCapabilities from '../../Components/stampingCapabilities'

const listStamping = [
    {
        img: stamping
    },
    {
        img: stamping2
    },
    {
        img: stamping3
    },
    {
        img: stamping4
    },
    {
        img: stamping5
    },
    {
        img: stamping6
    },
    {
        img: stamping7
    },
    {
        img: stamping8
    },
    {
        img: stamping9
    },
]



function StampingPage(){
  return (
    <div>
        <Header/>
        <StampingCapabilities
            listStamping = {listStamping}
        />
    </div>
  )
}

export default StampingPage